import axios from "axios";
import { SERVER_HOST } from "./config";
import { InputEntity, RequestEntity } from "../dtos/index";

const fileIdPrefix = "--file-upload-id-";

export default class Server {
  public fileId: number = 0;

  public toFormData(
    obj: any,
    formData: FormData = new FormData(),
    parentKey: string = ""
  ): FormData {
    for (const key in obj) {
      if (obj.hasOwnProperty(key)) {
        const fullKey = parentKey ? `${parentKey}[${key}]` : key;
        const value = obj[key];

        if (value instanceof Date) {
          const tzOffset = -value.getTimezoneOffset();
          const diffHours = Math.floor(tzOffset / 60);
          const diffMinutes = tzOffset % 60;
          const sign = diffHours >= 0 ? "+" : "-";
          const pad = (num: number) => String(num).padStart(2, "0");

          const formattedDate = `${value.getFullYear()}-${pad(
            value.getMonth() + 1
          )}-${pad(value.getDate())}T${pad(value.getHours())}:${pad(
            value.getMinutes()
          )}:${pad(value.getSeconds())}${sign}${pad(Math.abs(diffHours))}:${pad(
            diffMinutes
          )}`;

          formData.append(fullKey, formattedDate);
        } else if (value instanceof File || value instanceof Blob) {
          formData.append(fullKey, fileIdPrefix + this.fileId);
          formData.append(fileIdPrefix + this.fileId++, value);
        } else if (typeof value === "object" && value !== null) {
          this.toFormData(value, formData, fullKey);
        } else {
          if (value !== undefined && value !== null)
            formData.append(fullKey, value);
        }
      }
    }

    return formData;
  }

  constructor(
    protected readonly uri: string,
    protected readonly host: string = SERVER_HOST
  ) {}

  public get endpoint(): string {
    return this.host + this.uri;
  }

  public async get(
    params: RequestEntity | null | undefined = null
  ): Promise<any> {
    if (params === undefined || params === null)
      return (
        await axios.get(this.endpoint, {
          withCredentials: true,
        })
      ).data;

    return (
      await axios.get(this.endpoint, {
        withCredentials: true,
        params: Object.fromEntries(
          Object.entries(params).map(([key, value]) => [
            key,
            JSON.stringify(value),
          ])
        ),
      })
    ).data;
  }

  public post(
    data: InputEntity | null | undefined = null,
    params: RequestEntity | null | undefined = null
  ): Promise<any> {
    return axios({
      method: "post",
      url: this.endpoint,
      data: data ? this.toFormData(data) : undefined,
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
      params: params
        ? Object.fromEntries(
            Object.entries(params).map(([key, value]) => [
              key,
              JSON.stringify(value),
            ])
          )
        : undefined,
    });
  }

  public put(
    params: RequestEntity | null | undefined = null,
    data: InputEntity | null | undefined = null
  ): Promise<any> {
    return axios({
      method: "put",
      url: this.endpoint,
      data: data ? this.toFormData(data) : undefined,
      headers: { "Content-Type": "multipart/form-data" },
      withCredentials: true,
      params: params
        ? Object.fromEntries(
            Object.entries(params).map(([key, value]) => [
              key,
              JSON.stringify(value),
            ])
          )
        : undefined,
    });
  }

  public delete(params: RequestEntity | null | undefined = null): Promise<any> {
    return axios({
      method: "delete",
      url: this.endpoint,
      withCredentials: true,
      params: params
        ? Object.fromEntries(
            Object.entries(params).map(([key, value]) => [
              key,
              JSON.stringify(value),
            ])
          )
        : undefined,
    });
  }
}
